import React from "react";
import PropTypes from "prop-types";
import get from "lodash/get";

import AdCard from "../../Story-Elements/AdCard";
import StoryCard from "../../shared/StoryCard";
import { filterCards, getAdInsertPosition, isPartnershipCard } from "../../shared/card-utils";

import "../text-story.m.css";

const ArticleBody = ({ story, isLeadershipFocus }) => {
  const cards = get(story, ["cards"], []);
  const { adCards, regularCards } = filterCards(cards);

  const renderCardsWithAds = () => {
    const elements = [];
    const adInsertPosition = getAdInsertPosition(regularCards.length);

    // Track if previous card was a partnership card to apply style to next card's first title
    let prevWasPartnership = false;

    regularCards.forEach((card, index) => {
      const isPartnership = isPartnershipCard(card);
      const applyPartnershipStyle = prevWasPartnership;
      prevWasPartnership = isPartnership;

      elements.push(
        <StoryCard
          key={card.id || index}
          card={card}
          cardIndex={index}
          story={story}
          applyPartnershipStyleToFirstTitle={applyPartnershipStyle}
          isLeadershipFocus={isLeadershipFocus}
        />
      );

      // Add ads at the appropriate position
      if (adCards.length > 0 && index === adInsertPosition - 1) {
        adCards.forEach((adCard, adIndex) => {
          elements.push(
            <AdCard
              key={`ad-${adIndex}`}
              card={adCard}
              isDesktop={false}
            />
          );
        });
      }
    });

    return elements;
  };

  return (
    <div styleName="article-body" className="trinity-read" data-trinity-content="true">
      {renderCardsWithAds()}
    </div>
  );
};

ArticleBody.propTypes = {
  story: PropTypes.object.isRequired,
  isLeadershipFocus: PropTypes.bool,
};

export default ArticleBody;
